import { useState, useEffect } from 'react';
import _ from 'lodash';

import { useRequest } from '.';

const useFetch = <T>(url?: string, params?: object, initialValue?: T) => {
  const [data, setData] = useState<T | undefined | Error>(initialValue);
  const [attr, setAttr] = useState(params);

  const request = useRequest();

  useEffect(() => {
    if (url) {
      const source = request<T>({
        url,
        params: attr,
        onSuccess: setData,
        onError: setData,
      });

      return () => source.cancel();
    }
  }, [request, url, attr]);

  useEffect(() => {
    if (!_.isEqual(attr, params)) {
      setAttr(params);
    }
  }, [attr, params]);

  if (data instanceof Error) {
    return { request, error: data };
  }

  return { request, data };
};

export default useFetch;
